import * as React from 'react';
import * as styles from './common.module.scss';

interface Props {
  text: string;
  title?: string;
  deactive?: boolean;
  handleClick: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  preventDefault?: boolean;
}
const TertiaryButton = ({ text, title, deactive, handleClick, preventDefault = true }: Props) => {
  if (deactive) {
    return <div />;
  }
  return (
    <button
      className={styles.tertiary}
      title={title}
      onClick={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (preventDefault) {
          event.preventDefault();
        }
        handleClick(event);
      }}
    >
      {text}
    </button>
  );
};

export default TertiaryButton;
